import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Switch, Space, Slider, Spin } from "antd";
import ControllerPicture from "../picture/controller";

export default function AirCassette(props) {
  const [data, setData] = useState({
    device_fanspeed: "hight",
    device_id: "ac",
    device_mode: "cool",
    device_model: "daikin",
    device_name: "air 1",
    device_status: "off",
    device_sweep: "on",
    device_temp: "15",
    device_type: "ac",
    id: 0,
    mac: "84F3EBA16081",
    select_scene: "false",
  });

  useEffect(() => {
    if (props.data) {
      setData(props.data);
    }
    return () => {
      // setData({})
    };
  }, [props.data]);

  useEffect(() => {
    props.getData(data);
    return () => {};
  }, [data]);

  const modes = [
    {
      key: 1,
      name: "Fan",
      status: "off",
    },
    {
      key: 2,
      name: "Cool",
      status: "off",
    },
    {
      key: 3,
      name: "Auto",
      status: "off",
    },
  ];

  const marksBtnFan = [
    {
      value: 0,
      nameBtn: "Low",
    },
    {
      value: 25,
      nameBtn: "Mid",
    },
    {
      value: 50,
      nameBtn: "High",
    },
    {
      value: 75,
      nameBtn: "Quiet",
    },
    {
      value: 100,
      nameBtn: "Auto",
    },
  ];

  const fanspeed = (value) => {
    if (value === "low") {
      return 0;
    } else if (value === "medium") {
      return 25;
    } else if (value === "hight") {
      return 50;
    } else if (value === "quiet") {
      return 75;
    } else if (value === "auto") {
      return 100;
    } else {
      return 0;
    }
  };

  const controllerTemp = (value) => {
    const number = parseInt(data["device_temp"]) + value;
    if (number >= 15 && number <= 30) {
      setData({
        ...data,
        device_temp: String(parseInt(data.device_temp) + value),
      });
    }
  };

  const controllerSpeed = (value) => {
    let speed = "low";
    if (value === 0) {
      speed = "low";
    } else if (value === 25) {
      speed = "medium";
    } else if (value === 50) {
      speed = "hight";
    } else if (value === 75) {
      speed = "quiet";
    } else if (value === 100) {
      speed = "auto";
    } else {
      speed = "low";
    }

    setData({ ...data, device_fanspeed: speed });
  };

  return (
    <div>
      {data.select_scene === "false" ? (
        <div style={styles.cardOff}>
          <Row gutter={[12, 12]}>
            <Col span={5} style={{ width: "250px" }}>
              <div
                onClick={() => {
                  setData({
                    ...data,
                    select_scene: "true",
                    device_status: "on",
                  });
                }}
              >
                {ControllerPicture.air()}
              </div>
            </Col>
            <Col span={19}>
              <Row>
                <Col span={17}>
                  <div
                    style={styles.fontHeadOff}
                    onClick={() => {
                      setData({
                        ...data,
                        select_scene: "true",
                        device_status: "on",
                      });
                    }}
                  >
                    Air Conditioner
                  </div>
                </Col>
                <Col span={7} style={{ textAlign: "end", paddingTop: "3px" }}>
                  <Space direction="vertical" style={{ marginLeft: "23%" }}>
                    <Switch
                      disabled
                      checked={data["device_status"] === "on" ? true : false}
                      checkedChildren="ON"
                      unCheckedChildren="OFF"
                    />
                  </Space>
                </Col>
              </Row>
              <div style={{ marginTop: "2%" }}>
                <Row>
                  <Col span={8} style={{ width: "250px", textAlign: "center" }}>
                    {ControllerPicture.minusD()}
                  </Col>
                  <Col span={8} style={styles.fontNumber}>
                    {data["device_temp"]}°
                  </Col>
                  <Col span={8} style={{ width: "250px", textAlign: "center" }}>
                    {ControllerPicture.plusD()}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <div>
            <Row gutter={[16, 16]} style={{ marginTop: "10px" }}>
              {modes.map((e, i) => {
                return (
                  <Col span={8} key={i + "_mode"}>
                    <div
                      style={
                        data["device_mode"] === e.name.toLowerCase()
                          ? styles.cardModeActionOff
                          : styles.cardModeOff
                      }
                    >
                      <div>
                        {e.name === "Fan" ? (
                          <>{ControllerPicture.dry()}</>
                        ) : null}
                        {e.name === "Cool" ? (
                          <>{ControllerPicture.cool()}</>
                        ) : null}
                        {e.name === "Auto" ? (
                          <>{ControllerPicture.auto()}</>
                        ) : null}
                      </div>
                      <div style={styles.fontInCardOff}>{e.name}</div>
                      {/* <div style={{ marginTop: "10px" }}>
                        <Switch
                          checked={false}
                          checkedChildren="ON"
                          unCheckedChildren="OFF"
                        />
                      </div> */}
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
          {/* Start Mode Fan */}
          <Row>
            <Col span={5}>
              <Row>
                <Col span={12} style={{ width: "200px" }}>
                  {ControllerPicture.wind()}
                </Col>
                <Col span={12}>
                  <div style={styles.fontInpage}>Fan</div>
                </Col>
              </Row>
            </Col>
          </Row>
          <div style={styles.cardInervOff}>
            <div>
              <Row gutter={[16, 8]} justify="center" align="middle">
                {marksBtnFan.map((item) => (
                  <Col key={item.value} span={4}>
                    <div
                      style={
                        item.value === fanspeed(data["device_fanspeed"])
                          ? styles.btnFanChooseOff
                          : styles.btnFanOff
                      }
                    >
                      {item.nameBtn}
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
          {/* End Mode Fan */}

          {/* Start Mode Swing */}
          <div>
            <Row gutter={[16, 8]} justify="center" align="middle">
              <Col span={11}>
                <Row gutter={[16, 4]}>
                  <Col span={16}>
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      {ControllerPicture.fanSwing()}
                    </div>
                  </Col>
                  <Col span={8}>
                    <div
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                      }}
                    >
                      Swing
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col span={13}>
                <Row>
                  <Col span={12}>
                    <div style={styles.textInbtn}>
                      <div
                        style={
                          data["device_sweep"] === "off"
                            ? styles.btnSwingChooseOff
                            : styles.btnSwingoff
                        }
                      >
                        {ControllerPicture.fanStop()}
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          marginTop: "8px",
                          fontWeight: "500",
                        }}
                      >
                        Stop
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div style={styles.textInbtn}>
                      <div
                        style={
                          data["device_sweep"] === "on"
                            ? styles.btnSwingChooseOff
                            : styles.btnSwingoff
                        }
                      >
                        {ControllerPicture.fanSwing()}
                      </div>
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        marginTop: "8px",
                        fontWeight: "500",
                      }}
                    >
                      Swing
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          {/* End Mode Swing */}
        </div>
      ) : null}
      {data.select_scene === "true" ? (
        <div style={styles.cardAction}>
          <Row gutter={[12, 12]}>
            <Col span={5} style={{ width: "250px" }}>
              <div
                onClick={() => {
                  setData({
                    ...data,
                    select_scene: "false",
                    device_status: "off",
                  });
                }}
              >
                {ControllerPicture.air()}
              </div>
            </Col>
            <Col span={19}>
              <Row>
                <Col span={17}>
                  <div
                    style={styles.fontHead}
                    onClick={() => {
                      setData({
                        ...data,
                        select_scene: "false",
                        device_status: "off",
                      });
                    }}
                  >
                    Air Conditioner
                  </div>
                </Col>
                <Col span={7} style={{ textAlign: "end", paddingTop: "3px" }}>
                  <Space direction="vertical" style={{ marginLeft: "23%" }}>
                    <Switch
                      onChange={(e) => {
                        let status = "off";
                        if (e) {
                          status = "on";
                        }
                        setData({ ...data, device_status: status });
                      }}
                      checked={data["device_status"] === "on" ? true : false}
                      checkedChildren="ON"
                      unCheckedChildren="OFF"
                    />
                  </Space>
                </Col>
              </Row>
              <div style={{ marginTop: "2%" }}>
                <Row>
                  <Col span={8} style={{ width: "250px", textAlign: "center" }}>
                    {data["device_mode"] !== "fan" &&
                    data["device_status"] === "on" ? (
                      <div
                        onClick={() => {
                          controllerTemp(-1);
                        }}
                      >
                        {ControllerPicture.minus()}
                      </div>
                    ) : (
                      <div>{ControllerPicture.minusD()}</div>
                    )}
                  </Col>
                  <Col span={8} style={styles.fontNumber}>
                    {data["device_temp"]}°
                  </Col>
                  <Col span={8} style={{ width: "250px", textAlign: "center" }}>
                    {data["device_mode"] !== "fan" &&
                    data["device_status"] === "on" ? (
                      <div
                        onClick={() => {
                          controllerTemp(1);
                        }}
                      >
                        {ControllerPicture.plus()}
                      </div>
                    ) : (
                      <div>{ControllerPicture.plusD()}</div>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <div>
            <Row gutter={[16, 16]} style={{ marginTop: "10px" }}>
              {modes.map((e, i) => {
                return (
                  <Col span={8} key={i + "_mode"}>
                    <div
                      style={
                        data["device_mode"].toLowerCase() ===
                        e.name.toLowerCase()
                          ? styles.cardModeChoose
                          : styles.cardMode
                      }
                      onClick={() => {
                        setData({
                          ...data,
                          device_mode: e.name.toLowerCase(),
                        });
                      }}
                    >
                      <div>
                        {e.name === "Fan" ? (
                          <>{ControllerPicture.dry()}</>
                        ) : null}
                        {e.name === "Cool" ? (
                          <>{ControllerPicture.cool()}</>
                        ) : null}
                        {e.name === "Auto" ? (
                          <>{ControllerPicture.auto()}</>
                        ) : null}
                      </div>
                      <div style={styles.fontInCard}>{e.name}</div>
                      {/* <div style={{ marginTop: "10px" }}>
                        <Switch
                        disabled={data["device_status"] === "off" ? true : false}
                          onChange={() => {
                            setData({
                              ...data,
                              device_mode: e.name.toLowerCase(),
                            });
                          }}
                          checked={
                            data["device_mode"].toLowerCase() ===
                            e.name.toLowerCase()
                              ? true
                              : false
                          }
                          checkedChildren="ON"
                          unCheckedChildren="OFF"
                        />
                      </div> */}
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
          {/* Start Mode Fan */}
          <Row>
            <Col span={5}>
              <Row>
                <Col span={12} style={{ width: "200px" }}>
                  {ControllerPicture.wind()}
                </Col>
                <Col span={12}>
                  <div style={styles.fontInpage}>Fan</div>
                </Col>
              </Row>
            </Col>
          </Row>
          <div style={styles.cardInerv}>
            <div>
              <Row gutter={[16, 8]} justify="center" align="middle">
                {marksBtnFan.map((item) => (
                  <Col key={item.value} span={4}>
                    <div
                      style={
                        item.value === fanspeed(data["device_fanspeed"])
                          ? styles.btnFanChoose
                          : styles.btnFan
                      }
                      onClick={() => controllerSpeed(item.value)}
                    >
                      {item.nameBtn}
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
          {/* End Mode Fan */}

          {/* Start Mode Swing */}
          <div>
            <Row gutter={[16, 8]} justify="center" align="middle">
              <Col span={11}>
                <Row gutter={[16, 4]}>
                  <Col span={16}>
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      {ControllerPicture.fanSwing()}
                    </div>
                  </Col>
                  <Col span={8}>
                    <div
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                      }}
                    >
                      Swing
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col span={13}>
                <Row>
                  <Col span={12}>
                    <div style={styles.textInbtn}>
                      <div
                        style={
                          data["device_sweep"] === "off"
                            ? styles.btnSwingChoose
                            : styles.btnSwing
                        }
                        onClick={() => {
                          setData({ ...data, device_sweep: "off" });
                        }}
                      >
                        {ControllerPicture.fanStop()}
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          marginTop: "8px",
                          fontWeight: "500",
                        }}
                      >
                        Stop
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div style={styles.textInbtn}>
                      <div
                        style={
                          data["device_sweep"] === "on"
                            ? styles.btnSwingChoose
                            : styles.btnSwing
                        }
                        onClick={() => {
                          setData({ ...data, device_sweep: "on" });
                        }}
                      >
                        {ControllerPicture.fanSwing()}
                      </div>
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        marginTop: "8px",
                        fontWeight: "500",
                      }}
                    >
                      Swing
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          {/* End Mode Swing */}
        </div>
      ) : null}
    </div>
  );
}

const styles = {
  head: {
    backgroundColor: "#F0F9FB",
    height: "108px",
  },
  card: {
    display: "flex",
    padding: "16px",
    flexDirection: "column",
    // alignItems: "flex-start",
    gap: "12px",
    borderRadius: "16px",
    border: "1px solid #B5EAEF",
    background: "#FBFBFB",
  },
  cardAction: {
    display: "flex",
    padding: "16px",
    flexDirection: "column",
    // alignItems: "flex-start",
    gap: "12px",
    borderRadius: "16px",
    border: "1px solid #B5EAEF",
    background: "#EBF4FA",
  },
  cardInerv: {
    flexShrink: "0",
    borderRadius: "16px",
    border: "1px solid #B5EAEF",
    background: "#FBFBFB",
    padding: "10px 15px 10px 8px",
  },
  fontInpage: {
    color: "#56585D",
    paddingTop: "2px",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px",
  },
  fontHead: {
    fontFamily: "Gotham",
    color: "#3EA8B8",
    textAlign: "center",
    paddingTop: "2px",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px" /* 150% */,
    // marginLeft: "25px",
  },
  fontInCard: {
    color: "#3EA8B8",
    textAlign: "center",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px" /* 150% */,
    // marginLeft: "10%",
  },
  fontNumber: {
    color: "#56585D",
    fontFamily: "Gotham",
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: "300",
    lineHeight: "32px",
    letterSpacing: "0.15px",
    textAlign: "center",
    marginTop: "10px",
  },
  textMode: {
    color: "#56585D",
    marginTop: "10px",
    textAlign: "center",
    fontFamily: "Gotham",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "21px" /* 175% */,
  },
  cardMode: {
    height: "75px",
    // width: "93px",
    textAlign: "center",
    flexShrink: "0",
    borderRadius: "16px",
    border: "1px solid #B5EAEF",
    background: "#FBFBFB",
    paddingTop: "15%",
  },
  cardModeChoose: {
    height: "75px",
    // width: "93px",
    textAlign: "center",
    flexShrink: "0",
    borderRadius: "16px",
    border: "1px solid #B5EAEF",
    background: "rgba(235, 244, 250, 1)",
    paddingTop: "15%",
  },

  fontHeadOff: {
    fontFamily: "Gotham",
    color: "#56585D",
    textAlign: "center",
    paddingTop: "2px",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px",
  },
  cardOff: {
    display: "flex",
    padding: "16px",
    flexDirection: "column",
    gap: "12px",
    borderRadius: "16px",
    border: "1px solid #E3E3E3",
    background: "#FBFBFB",
  },
  fontInCardOff: {
    color: "#56585D",
    textAlign: "center",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px",
  },
  fontInpageOff: {
    color: "#56585D",
    paddingTop: "2px",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px",
  },
  cardModeOff: {
    height: "75px",
    textAlign: "center",
    flexShrink: "0",
    borderRadius: "16px",
    border: "1px solid #E3E3E3",
    background: "#FBFBFB",
    paddingTop: "15%",
  },
  cardModeActionOff: {
    height: "75px",
    textAlign: "center",
    flexShrink: "0",
    borderRadius: "16px",
    border: "1px solid #E3E3E3",
    background: "#E3E3E3",
    paddingTop: "15%",
  },
  cardInervOff: {
    flexShrink: "0",
    borderRadius: "16px",
    border: "1px solid #E3E3E3",
    background: "rgba(251, 251, 251, 0.1)",
    padding: "10px 15px 10px 8px",
  },
  btnFan: {
    display: "flex",
    width: "30px" /* ปรับให้ปุ่มใหญ่ขึ้น */,
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #B5EAEF",
    background: "#FBFBFB",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    margin: "auto" /* จัดปุ่มให้อยู่กึ่งกลาง Col */,
    cursor: "pointer" /* ทำให้เป็น Cursor แบบคลิกได้ */,
  },
  btnFanChoose: {
    display: "flex",
    width: "30px",
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #B5EAEF",
    background: "rgba(235, 244, 250, 1)",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    fontWeight: "bold",
    margin: "auto",
    cursor: "pointer",
  },
  btnFanOff: {
    display: "flex",
    width: "30px",
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#FBFBFB",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    margin: "auto",
    cursor: "pointer",
  },
  btnFanChooseOff: {
    display: "flex",
    width: "30px",
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#E3E3E3",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    fontWeight: "bold",
    margin: "auto",
    cursor: "pointer",
  },

  btnSwing: {
    display: "flex",
    width: "40px",
    height: "40px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#FBFBFB",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
  },
  btnSwingChoose: {
    display: "flex",
    width: "40px",
    height: "40px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #B5EAEF",
    background: "rgba(235, 244, 250, 1)",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
  },
  textInbtn: {
    display: "flex",
    flexDirection: "column" /* เรียงแนวตั้ง */,
    justifyContent: "center" /* จัดกึ่งกลางแนวตั้ง */,
    alignItems: "center" /* จัดกึ่งกลางแนวนอน */,
    textAlign: "center",
  },

  btnSwingoff: {
    display: "flex",
    width: "40px",
    height: "40px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#FBFBFB",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
  },
  btnSwingChooseOff: {
    display: "flex",
    width: "40px",
    height: "40px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#E3E3E3",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
  },
};
